import Permissions from './Permissions';
import PermissionsFilters from './Filters';
import Selection from './Selection';
import Modals from './Modals';
import Roles from './Roles';
import Users from './Users';
import ContactService from '../../../services/contact_service';

const List = (vm) => {
  const permissions = Permissions(vm.permission);
  const filters = PermissionsFilters({ losesAccess: vm.losesAccess });

  const usersState = Users({
    logout: vm.logout,
    message: vm.message,
    canSeeAdmin: permissions.canSeeAdmin,
    query: filters.query,
    findRole: filters.findRole,
    sortConfig: filters.sortConfig,
    onResetSelection: () => {},
  });

  const selection = Selection({
    users: usersState.users,
    losesAccess: vm.losesAccess,
  });

  const rolesState = Roles({
    logout: vm.logout,
    message: vm.message,
  });

  const modals = Modals({
    losesAccess: vm.losesAccess
  });

  const refreshUsers = async () => {
    await usersState.fetchUsers();
  };

  const updateUser = () => {
    filters.setQuery('');
    refreshUsers();
  };

  const handleConfirmDelete = async () => {
    try {
      const lostAccess = await vm.losesAccess?.();
      if (lostAccess) return;
      modals.setConfirm((prev) => ({
        ...prev,
        loading: true,
        error: '',
      }));
      await Promise.all(
        modals.confirm.ids.map(async (id) => {
          const result = await ContactService.delete(id);
          if (vm.logout(result)) return;
          return result;
        })
      );
      vm.message('Registros Eliminados correctamente', 'success');
      await usersState.fetchUsers();
      selection.clearSelection();
      modals.closeDeleteModal();
    } catch (e) {
      modals.setConfirm((prev) => ({
        ...prev,
        loading: false,
        error: e.message || 'Error eliminando',
      }));
    } finally {
      modals.setConfirm((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  return {
    ...permissions,
    ...filters,
    ...selection,
    ...rolesState,
    ...usersState,
    ...modals,
    updateUser,
    handleConfirmDelete,
  };
};

export default List;
